<template>
  <div class="invoice-index">
    <div class="invoice-index-detail">
      <slot name="detail-header">
        <slot name="detail-content"></slot>
        <OrderDetail
          :invoiceDetailData="invoiceDetailData"
          :model="modelDetail"
        />
      </slot>
      <slot name="other-content"></slot>
      <InvoiceFillForm
        :invoiceDetailData="invoiceDetailData"
        :getCompanyOptions="getCompanyNameOptions"
        :getTaxCode="getTaxCode"
        :modelData="model"
        :moreInfoData="moreInfo"
        @confirm="confirmInvoice"
        @confirmModify="confirmModify"
        @cancleModify="cancleModify"
        @changeModel="changeModel"
        @changeMoreInfo="changeMoreInfo"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import OrderDetail from './OrderDetail.vue';
import InvoiceFillForm from './InvoiceForm.vue';
import { InvoiceDetail, MoreInfo, InvoiceModel } from './types';

@Component({
  components: {
    OrderDetail,
    InvoiceFillForm,
  },
  model: {
    prop: 'invoiceDetailData',
    event: 'updateInvoiceDetail',
  },
})
export default class InvoiceIndex extends Vue {
  @Prop({ type: Object })
  invoiceDetailData!: InvoiceDetail;
  @Prop({ type: Object })
  moreInfo!: MoreInfo;
  @Prop({ type: Object })
  model!: InvoiceModel;
  changeModel(model: InvoiceModel) {
    this.$emit('update:model', model);
  }
  @Prop({
    type: Array,
    default() {
      return [
        {
          key: 'order_no',
          title: '订单编号',
          value: '',
        },
        {
          key: 'paid_time',
          title: '下单时间',
          value: '',
        },
        {
          key: 'amount',
          title: '金额',
          value: '',
        },
      ];
    },
  })
  modelDetail!: [];
  changeMoreInfo(moreInfo: MoreInfo) {
    this.$emit('update:moreInfo', moreInfo);
  }
  async getTaxCode(id: any) {
    let result: any = [];
    await window.apis
      .getTaxCode({ id: id })
      .then((res: any) => {
        result = (res.data && res.data.uncid) || '';
        //  this.$set(this.model,'tax_code',res.data && res.data.uncid)
      })
      .catch((e: any) => {
        console.log('error:', e);
        return [];
      });
    return result;
  }

  async getCompanyNameOptions(value: string) {
    let result: any = [];
    await window.apis
      .getCompanyName({ keyword: value })
      .then((res: any) => {
        result = res.data || [];
      })
      .catch((e: any) => {
        console.log('error:', e);
        return [];
      });

    return result;
  }

  confirmModify(...args: any) {
    const model: InvoiceModel = args[0];
    const moreInfo: MoreInfo = args[1];
    this.$emit(
      'updateInvoiceDetail',
      { ...this.invoiceDetailData, ...model, ...moreInfo}
    );
    this.$emit('confirmInvoice', model, moreInfo);
  }

  cancleModify(value: any) {
    this.$emit('cancleModify', value);
  }

  confirmInvoice(...args: any) {
    const model: InvoiceModel = args[0];
    const moreInfo: MoreInfo = args[1];
    this.$emit(
      'updateInvoiceDetail',
      { ...this.invoiceDetailData, ...model, ...moreInfo}
    );
    this.$emit('confirmInvoice', model, moreInfo);
  }
}
</script>

<style lang="scss" scoped>
.invoice-index {
  padding-bottom: calc(172px + constant(safe-area-inset-bottom));
  padding-bottom: calc(172px + env(safe-area-inset-bottom));
  background-color: #f4f4f4;
}
</style>
